import websitePage, { HEADER_TYPE_NO_MENU_NO_APPLICATION } from '../../hoc/websitePage/websitePage';
import GAT from '../../screens/GAT/GAT';

export default websitePage(GAT, {
  routeKey: 'GAT',
  header: HEADER_TYPE_NO_MENU_NO_APPLICATION,
});
